import React from 'react';
import './Loader.css';
import logoImage from '../../assets/images/logo.png';

function Loader({ onAnimationEnd }) {
  return (
    <div className="loader-container" onAnimationEnd={onAnimationEnd}>
      <div className="loader-curtain left"></div>
      <div className="loader-curtain right"></div>
      <div className="loader-logo-container">
        <img src={logoImage} alt="Loading Logo" className="loader-logo" />
      </div>
    </div>
  );
}

export default Loader;